module.exports = __webpack_public_path__ + "img/ctrl-cross-resonance-stub-1.4fd4d78f.svg";